// config.js
var query = parseQuery(window.location.search.substring(1));

var isProd = window.location.origin.indexOf("tooncoin.com") > 0
  || window.location.origin.indexOf("toontoken.com") > 0;

var isDebug = !!query["debug"];

var contractAddresses = {
  mainnet: "0xE8078B5198E572Be8D8D412511d48b7D0f5E9a1c",
  rinkeby: "0x7E3BA0bCD192155ac7b9E51613C639e4e026d2dD",
};

var networkVersions = {
  mainnet: 1,
  rinkeby: 4,
}

var etherscan = {
  mainnet: "https://etherscan.io",
  rinkeby: "https://rinkeby.etherscan.io",
}
// \config.js

var isVotePage = window.location.pathname === "/vote.html";

function parseQuery(str) {
  var res = {};

  if (str.length === 0) {
    return res;
  }

  str.split("&").forEach((param) => {
    var data = param.split("=");
    res[decodeURIComponent(data[0])] = decodeURIComponent(data[1]);
  });

  return res;
}

function getEtherscanDomain() {
  switch (parseInt(window.ethereum.networkVersion)) {
    case networkVersions.mainnet:
      return etherscan.mainnet;
    case networkVersions.rinkeby:
      return etherscan.rinkeby;
    default:
      return null;
  }
}

var R2d2Contract = null;
var R2d2AbiLoad = fetch("./R2d2V0Extended.abi.json").then(function(res) {
  return res.json();
});

function getR2d2ContractAddresses() {
  switch (parseInt(window.ethereum.networkVersion)) {
    case networkVersions.mainnet:
      return contractAddresses.mainnet;
    case networkVersions.rinkeby:
      return contractAddresses.rinkeby;
    default:
      return null;
  }
}

function getR2d2Contract() {
  return R2d2AbiLoad
    .then(function (abi) {
      var R2d2ContractAddress = getR2d2ContractAddresses();

      if (!R2d2ContractAddress) {
        var error = new Error("Unrecognized network");
        error.code = 1001;

        throw error;
      }

      return new window.web3.eth.Contract(abi, R2d2ContractAddress);
    })
    .then(function (contract) {
      R2d2Contract = contract;

      return contract;
    });
}

function metamaskAuthentification() {
  return getCurrentAccount()
    .then(function (account) {
      return window.web3.eth.net.getId();
    })
    .then(function (networkVersions) {
      window.ethereum.networkVersion = networkVersions;

      var networkVersionsError = (isProd && !isDebug && window.ethereum.networkVersion != networkVersions.mainnet)
        || (isDebug && Object.values(networkVersions).indexOf(parseInt(window.ethereum.networkVersion)) === -1);

      if (networkVersionsError) {
        var error = new Error("Unrecognized network");
        error.code = 1001;

        throw error;
      }

      return networkVersions;
    })
    .then(function () {
      return getR2d2Contract();
    })
    .then(function (contract) {
      return contract.methods.balanceOf(window.ethereum.selectedAddress).call();
    })
    .then(function (balance) {
      if (balance === "0") {
        var error = new Error("Zero balance");
        error.code = 1002;

        throw error;
      }

      return balance;
    });
}

$(document).ready(function() {
  if (!isVotePage) {
    return;
  }

  if (window.ethereum) {

    if (window.ethereum.isMetaMask) {
      window.ethereum.on("accountsChanged", function(accounts) {
        if (accounts.length > 0) {
          auth();
        }
        else {
          resetVotePage();
          $(".vote__auth").removeClass("hidden");
        }
      });

      window.ethereum.on("chainChanged", function(chainId) {
        auth();
      });
    }

    if (window.ethereum.selectedAddress == null) {
      $(".vote__auth").removeClass("hidden");
    } else {
      auth();
    }
  } else {
    $(".vote__download_metamask_wrapper").removeClass("hidden");
  }

  function auth() {
    resetVotePage();

    $(".vote__auth_loading").removeClass("hidden");

    return metamaskAuthentification()
      .then(function (balance) {
        return initVoteForm(balance);
      })
      .then(function (res) {
        $(".vote__auth_loading").addClass("hidden");
        $(".vote__form_wrapper").removeClass("hidden");
      })
      .catch(function (error) {
        $(".vote__auth_loading").addClass("hidden");

        if (error.code === 1001) {
          if (isProd && !isDebug) {
            $(".vote__message .network_prod").removeClass("hidden");
          } else {
            $(".vote__message .network_debug").removeClass("hidden");
          }
        }
        else if (error.code === 1002) {
          $(".vote__zero_balance_wrapper span.address").text(window.ethereum.selectedAddress);
          $(".vote__zero_balance_wrapper").removeClass("hidden");
        }

        throw error;
      });

  }

  function resetForm() {
    $(".vote__form_wrapper").addClass("hidden");
    $(".vote__form_message_error").text("").addClass("hidden");
    $(".vote__form_loading").addClass("hidden");
    $(".vote__form input[type=text]").val("");

    $(".vote__form_message_success").find("a").attr("href", "");
    $(".vote__form_message_success").addClass("hidden");

    $(".vote__form_balance span.balance").text("");

    $(".vote__form .button").prop("disabled", false).removeClass("disabled");
  }

  function resetVotePage() {
    $(".vote__download_metamask_wrapper").addClass("hidden");
    $(".vote__auth_loading").addClass("hidden");
    $(".vote__auth").addClass("hidden");

    $(".vote__zero_balance_wrapper").addClass("hidden");
    $(".vote__zero_balance_wrapper span.address").text("");

    $(".vote__message .network_prod").addClass("hidden");
    $(".vote__message .network_debug").addClass("hidden");
    $(".vote__message .login").addClass("hidden");

    resetForm();
  }

  function initVoteForm(balance) {
    return R2d2Contract.methods.candidateOf(window.ethereum.selectedAddress).call()
      .then(function (res) {
        $(".vote__form_balance span.balance").text(window.web3.utils.fromWei(balance));

        var addressInput = $(".vote__form").find("input[value='" + res + "']");

        if (addressInput.length > 0) {
          addressInput.prop("checked", true);
        } else {
          $(".vote__form input[type=text]").val(res);
          $(".vote__form .alternative-address").prop("checked", true).val(res);
        }

        return true;
      });
  }

  $(".vote__auth button").on("click", function() {
    auth()
      .then()
      .catch(function (error) {
        console.error(error);

        if (error.code == 4001) {
          $(".vote__auth").removeClass("hidden");
        }

        if (error.code == -32002) {
          $(".vote__message .login").removeClass("hidden");
        }
      });
  });

  $(".vote__form input[type=text]")
    .on("change", function (e) {
      $(".vote__form_message_error").text("").addClass("hidden");
      $(".vote__form .alternative-address").val(e.target.value);
    })
    .on("focus", function (e) {
      $(".vote__form .alternative-address").prop("checked", true);
    });

  $(".vote__form").on("submit", function (e) {
    e.preventDefault();

    if ($(".vote__form .button").hasClass("disabled")) {
      return;
    }

    var address = $("input[name=address]:checked", this).val();

    if ($.trim(address) === "") {
      $(".vote__form_message_error").text("invalid address").removeClass("hidden");
      return;
    }

    try {
      window.web3.eth.getCode(address);
    } catch (error) {
      $(".vote__form_message_error").text(error.message).removeClass("hidden");
      return;
    }

    $(".vote__form .button").prop("disabled", true).addClass("disabled");
    $(".vote__form_message_error").text("").addClass("hidden");
    $(".vote__form_message_success").find("a").attr("href", "");
    $(".vote__form_message_success").addClass("hidden");
    $(".vote__form_loading").removeClass("hidden");

    R2d2Contract.methods.vote(address).send({from: window.ethereum.selectedAddress})
      .on("transactionHash", function(hash) {
        var etherscanLink = getEtherscanDomain() + "/tx/" + hash;

        $(".vote__form .button").prop("disabled", false).removeClass("disabled");
        $(".vote__form_loading").addClass("hidden");
        $(".vote__form_message_success").find("a").attr("href", etherscanLink);
        $(".vote__form_message_success").removeClass("hidden");
      })
      .then(function(receipt) {
        console.log("receipt:", receipt);
      })
      .catch(function(error, receipt) {
        console.error(error);

        $(".vote__form .button").prop("disabled", false).removeClass("disabled");
        $(".vote__form_loading").addClass("hidden");
        $(".vote__form_wrapper").removeClass("hidden");

        if (error.code == 4001) {
          return;
        }

        $(".vote__form_message_error").text(error.message).removeClass("hidden");
      });
  });
});